import { useTranslation, Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import campaignIcon from "../../../static/assets/campaign.svg";

const QualityPriorityAlert = ({ priorityAction }) => {
  const { t } = useTranslation();
  const history = useHistory();

  if (!priorityAction) return null;

  const handleLaunchCampaign = () => {
    history.push("/campaign/create", {
      fromBilans: {
        fluxLabel: priorityAction.fluxLabel,
        trackedMaterial: priorityAction.dominantCause || null,
      },
    });
  };

  return (
    <section className="statistics-alert statistics-alert--priority">
      <div className="flex flex-row items-start gap-3">
        <img
          src={campaignIcon}
          alt=""
          width={20}
          height={16}
          className="mt-1"
        />
        <div className="flex flex-col gap-2">
          <span className="font-semibold text-[#64481B]">
            {t("Priority action")}
          </span>

          <div className="flex flex-col text-[#64481B] text-sm">
            <span>
              <Trans
                i18nKey="quality.priorityByFlux"
                values={{
                  share: priorityAction.share,
                  flux: priorityAction.fluxLabel,
                  count: priorityAction.count,
                  cause: priorityAction.dominantCause
                    ? t(priorityAction.dominantCause)
                    : t("quality.unknownCause"),
                }}
                components={{
                  bold: <span className="font-semibold" />,
                }}
              />
            </span>
          </div>

          <button
            type="button"
            onClick={handleLaunchCampaign}
            className="self-start mt-1 flex items-center gap-2 px-4 py-2 rounded-full bg-[#64481B] text-white text-sm font-medium hover:opacity-90 transition-opacity"
          >
            <img src={campaignIcon} alt="" width={14} height={11} />
            {t("quality.launchCampaign", { flux: priorityAction.fluxLabel })}
          </button>
        </div>
      </div>
    </section>
  );
};

export default QualityPriorityAlert;
